import styled, { css } from 'styled-components'
import { GRAY_INFO, RED, MAIN_BACKGROUND } from 'constants/colors'
import { Flex } from 'components/common/styles'
import { StyledSelectInput } from 'components/common/Inputs/styles'

export const DaysContainer = styled(Flex)<{ error?: boolean }>`
  border: 1px solid ${GRAY_INFO};
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  ${({ error }) =>
    error &&
    css`
      border: 1px solid ${RED};
    `}
`

export const Day = styled(Flex)<{ noBorder?: boolean; selected?: boolean }>`
  padding: 5px 10px;
  border-right: ${({ noBorder }) => (noBorder ? 'none' : `solid ${GRAY_INFO}`)};
  border-width: 1px;
  width: 45px;
  cursor: pointer;
  ${({ selected }) =>
    selected &&
    css`
      background: ${MAIN_BACKGROUND};
    `}
  &:hover {
    background: ${MAIN_BACKGROUND};
  }
`

export const PlanNewJobSidebar = styled.div`
  ${StyledSelectInput}, .MuiTextField-root {
    margin: 0 0 0 8px;
  }

  .MuiFormControl-root .MuiSelect-select.MuiSelect-selectMenu {
    border: none;
  }
`

export const ModalTitle = styled(Flex)`
  height: 16px;
`
